import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../Components/Header";
import Swal from "sweetalert2";
import socket from "../Components/socket";
import { apiRequest } from "../../apiService/allApi";

const Redeem = ({ walletUpdate }) => {
  const history = useHistory();

  const [amount, setamount] = useState();
  const [userAllData, setUserAllData] = useState();
  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`me`, "GET", null, headers);
    setUserAllData(res.data);
  };

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }
    role();
  }, []);

  const deposit = async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest(
        `referral/to/wallet`,
        "POST",
        { amount },
        headers,
      );

      if (res.data.msg === "Invalid Amount") {
        Swal.fire({
          title: "You don't have sufficient amount",
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "success",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } else {
      let msg = "Enter Amount";
      if (!amount) {
        msg = "Enter Amount";
      } else if (95 <= amount <= 100000) {
        msg = "Amount should be more than 100.";
      }
      Swal.fire({
        title: msg,
        icon: "Error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <div className="leftContainer page_layout">
        <div className="Orher_page_main_section">
          <div className="refer_heading ">Redeem your refer balance</div>
          <img
            alt="Referral"
            className="w-75 m-auto d-flex"
            src="/images/refer_img.png"
          />
          <div className="refer_points">
            <div className="d-flex align-items-center">
              <div>
                <img
                  alt="Referral wallet"
                  src="/images/icons/refer-wallet.png"
                />
              </div>
              <p className="commaon_para mt-2">
                TDS (0%) will be deducted after annual referral earning of
                <img
                  className="mx-1"
                  src={process.env.PUBLIC_URL + "/images/rupee.png"}
                  alt=""
                  width="20x"
                  height="20x"
                />{" "}
                15,000.
              </p>
            </div>
            <div className="down-arrow">
              <img alt="Referral" src="/images/down-refer.png" />
            </div>

            <div className="d-flex align-items-center">
              <div>
                <img alt="Referral" src="/images/refer-box.png" />
              </div>
              <p className="commaon_para mb-0">
                Money will be added to King Mastar Coin.
              </p>
            </div>
            <div className="down-arrow">
              <img alt="Referral" src="/images/refer-right.png" />
            </div>
            <div className="d-flex align-items-center">
              <div>
                <img
                  alt="Referral wallet"
                  src="/images/icons/refer-wallet.png"
                />
              </div>
              <p className="commaon_para mb-0">
                Minimum withdrawal amount{" "}
                <img
                  className="mx-1"
                  src={process.env.PUBLIC_URL + "/images/rupee.png"}
                  alt=""
                  width="20x"
                  height="20x"
                />{" "}
                100
              </p>
            </div>
          </div>
          <div className="add_amount_min_max mt-3">
            <p className="mb-1"> Enter Amount (Min: 100, Max: 10000)</p>
          </div>
          <div>
            <div className="MuiFormControl-root MuiTextField-root  ">
              <input
                class="commaon_input_box"
                type="number"
                style={{ width: "100%" }}
                value={amount}
                placeholder="Enter Amount"
                onChange={(e) => setamount(parseInt(e.target.value))}
              ></input>
            </div>
            <div className="add_cash_nest_btn">
              <button onClick={() => deposit()}>Redeem</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Redeem;
